import React, {useState} from "react"
import {Button, Input, message, Popconfirm, Table, Typography} from "antd";
import Column from "antd/es/table/Column";
import {AiOutlineDelete, BsPencil, IoMdClose} from "react-icons/all";
import Modal from "antd/es/modal/Modal";

function Year({data, editYearFunc, deleteYearFunc, addNewSubjectModal, closeAddNewItemModal, addNewItemFunc, loading}) {
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editModalData, setEditModalData] = useState(null);
  const [newYear, setNewYear] = useState(null);


  return (
      <div>
        <Table
            showSizeChanger={true}
            loading={loading}
            size={"middle"}
            dataSource={data}
            pagination={{position: ["none", "bottomLeft"]}}
            style={{width: '60%', padding: '3%'}}
        >
          <Column title="№" key="id" render={record => (
              <span>{record.id}</span>
          )}/>
          <Column title="Yil" key="year" render={record => (
              <span>{record.name}</span>
          )}/>
          <Column title="Action" key="status" render={record => (
              <div style={{
                display: 'flex',
                alignItems: 'center',
                width: '50%',
                justifyContent: 'space-between'
              }}>
                <BsPencil
                    className={"settingsDtmActionsIcon"}
                    onClick={() => {
                      setEditModalData(record)
                      setEditModalOpen(true)
                    }}/>
                <Popconfirm
                    title={"Tasdiqlash"}
                    okText={"O'chirish"}
                    cancelText={"Ortga"}
                    onConfirm={() => {
                      message.warn("O'chirish xizmati o'chgan!")
                      // deleteYearFunc(record)
                    }}>
                  <AiOutlineDelete className={"settingsDtmActionsIcon"}/>
                </Popconfirm>
              </div>
          )}/>
        </Table>
        <Modal
            visible={editModalOpen}
            closable={false}
            centered={true}
            onCancel={() => {
              setEditModalOpen(false)
            }}
            footer={null}
        >
          <div>
            <div
                onClick={() => {
                  setEditModalOpen(false)
                }}
                className={"settingsSubjectEditModalCloseIconCont"}>
              <IoMdClose/>
            </div>
            <Typography
                className={"settingsSubjectEditModalTitle"}>
              Yangilash
            </Typography>
            <div style={{
              display: 'flex',
              alignItems: "center",
              width: '80%',
              margin: '1vw auto'
            }}>
              <label className={"nameEditInputLabel"} htmlFor={"nameEditInput"}>Yil</label>
              <Input
                  type={"number"}
                  value={editModalData && editModalData.name}
                  id={"nameEditInput"}
                  onChange={(e) => {
                    setEditModalData({
                      ...editModalData,
                      name: e.target.value
                    })
                  }}/>
            </div>
            <div style={{
              display: "flex",
              justifyContent: "center"
            }}>
              <Button
                  type="primary"
                  className={"settingsEditModalSaveButton"}
                  onClick={() => {
                    if (editModalData.name) {
                      editYearFunc(editModalData)
                      setEditModalOpen(false)
                    } else {
                      message.error("Yil kiritilmagan!")
                    }
                  }}>
                Saqlash
              </Button>
            </div>
          </div>
        </Modal>
        <Modal
            visible={addNewSubjectModal}
            closable={false}
            centered={true}
            onCancel={() => {
              closeAddNewItemModal()
            }}
            footer={null}
        >
          <div>
            <div
                onClick={() => {
                  closeAddNewItemModal()
                }}
                className={"settingsSubjectEditModalCloseIconCont"}>
              <IoMdClose/>
            </div>
            <Typography
                className={"settingsSubjectEditModalTitle"}>
              Yil qo'shish
            </Typography>
            <div style={{
              display: 'flex',
              alignItems: "center",
              width: '80%',
              margin: '1vw auto'
            }}>
              <label className={"nameEditInputLabel"} htmlFor={"nameEditInput"}>Yil</label>
              <Input
                  id={"nameEditInput"}
                  onChange={(e) => {
                    setNewYear(e.target.value)
                  }}/>
            </div>
            <div style={{
              display: "flex",
              justifyContent: "center"
            }}>
              <Button
                  type="primary"
                  className={"settingsEditModalSaveButton"}
                  onClick={() => {
                    if (newYear) {
                      addNewItemFunc(newYear)
                    } else {
                      message.error("Yil kiritilmagan!")
                    }
                  }}>
                Saqlash
              </Button>
            </div>
          </div>
        </Modal>
      </div>
  )
}

export default Year
